<div class="fd-dialog">
  <div class="fd-header">
    <h2 class="fd-title">{{ data?.selectedPOS ? 'Editar punto de venta' : 'Nuevo punto de venta' }}</h2>
    <button type="button" class="fd-close" aria-label="Cerrar" (click)="closeClick()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="fd-body">
    <form class="fd-form" [formGroup]="pointSaleForm">
      <div class="fd-field">
        <label for="ps-franchise" class="fd-label">Franquicia</label>
        <input id="ps-franchise" class="fd-input" type="text" formControlName="companyName" placeholder="{{ data.companyName }}" required />
      </div>
      <div class="fd-field">
        <label for="ps-description" class="fd-label">Punto de venta</label>
        <input
          id="ps-description"
          class="fd-input"
          type="text"
          formControlName="description"
          placeholder="Nombre del punto de venta"
          required
        />
        @if (
          pointSaleForm.get('description')?.touched &&
          pointSaleForm.get('description')?.hasError('required')
        ) {
          <mat-error class="fd-error">Campo obligatorio.</mat-error>
        }
      </div>
    </form>
  </div>
  <div class="fd-actions">
    <button mat-stroked-button type="button" (click)="closeClick()">Cancelar</button>
    <button mat-flat-button type="button" (click)="onSubmit()">Guardar</button>
  </div>
</div>
